
import aerial_city from "../assets/aerial_city.jpg"
import construction_about from "../assets/construction_about.jpg"
import icons8_excel_48 from ".//icons8_excel_48.png"
import icons8_pdf_48 from "../assets/icons8_pdf_48.png"
import mori_solution_logo2 from "../assets/mori_solution_logo2.png"
import pdf_file_format from "../assets/pdf-file-format.png"
import bot_logo from "../assets/bot logo.png"
import image_bolt2 from "../assets/image bolt2.png"
import world_trade_center from "./world_trade_center.png"
import mori_specification_review from "./mori_specs.png"
import playWrightQuerydash from "./playWrightQuerydash.png"
import cadget_review from "./Cadget Review.png"
import create_advisor_tabular from "./Create Advisor tabular- review.png"
import main_chat_interface from "./main_chat_interface.png"
import chat_interface from "./chat_interface.png"

export const assets = {
    aerial_city,
    construction_about,
    icons8_excel_48,
    icons8_pdf_48,
    mori_solution_logo2,
    pdf_file_format,
    bot_logo,
    image_bolt2,
    world_trade_center,
    mori_specification_review,
    playWrightQuerydash,
    cadget_review,
    create_advisor_tabular,
    main_chat_interface,
    chat_interface,
}